module.exports = __webpack_public_path__ + "media/icons/offer-details-tyl-97121c7b.png";